export default __webpack_public_path__ + "static/media/Kids-hover.67d78278.svg";